import React from "react";
import moment from "moment";
import Pagination from "components/misc/Pagination";
import PropTypes from "prop-types";

const PaymentsTable = ({
  loading,
  filtered,
  currentPage,
  pageSize,
  setCurrentPage,
  handleApprove,
  handleReject,
  Tr,
  Td,
  Th,
  StatusBadge,
  Button
}) => {
  // Pagination logic
  const total = filtered.length;
  const totalPages = Math.ceil(total / pageSize);
  const startIdx = (currentPage - 1) * pageSize;
  const endIdx = startIdx + pageSize;
  const pageData = filtered.slice(startIdx, endIdx);

  return (
    <table className="min-w-full bg-white rounded-lg shadow-md">
      <thead>
        <tr>
          <Th>ID</Th>
          <Th>Casa</Th>
          <Th>Propietario</Th>
          <Th>Categoría</Th>
          <Th>Fecha</Th>
          <Th>Monto</Th>
          <Th>Referencia</Th>
          <Th>Estatus</Th>
          <Th>Acciones</Th>
        </tr>
      </thead>
      <tbody>
        {(() => {
          if (loading) {
            return [
              <tr key="loading">
                <Td colSpan={9}>Cargando...</Td>
              </tr>
            ];
          } else if (filtered.length === 0) {
            return [
              <tr key="empty">
                <Td colSpan={9}>No hay pagos encontrados.</Td>
              </tr>
            ];
          } else {
            return [
              ...pageData.map(p => {
                let statusLabel = '';
                if (p.status === 0) statusLabel = 'Pendiente';
                else if (p.status === 1) statusLabel = 'Aprobado';
                else statusLabel = 'Rechazado';

                return (
                  <Tr key={p.paymentId}>
                    <Td>{p.paymentId}</Td>
                    <Td>{p.house || '-'}</Td>
                    <Td>{p.ownerName || '-'}</Td>
                    <Td>{p.category}</Td>
                    <Td>{moment(p.createdDate).format('YYYY-MM-DD')}</Td>
                    <Td>${p.balance}</Td>
                    <Td>{p.referenceNumber || '---'}</Td>
                    <Td><StatusBadge status={p.status}>{statusLabel}</StatusBadge></Td>
                    <Td>
                      <Button
                        onClick={() => handleApprove(p.paymentId)}
                        disabled={p.status === 1}
                        className={p.status === 1 ? "opacity-50 cursor-not-allowed bg-gray-400" : ""}
                      >
                        Aprobar
                      </Button>
                      <Button
                        tw="bg-red-500 hover:bg-red-700"
                        onClick={() => handleReject(p.paymentId)}
                        disabled={p.status === 2}
                        className={p.status === 2 ? "opacity-50 cursor-not-allowed bg-gray-400" : ""}
                      >
                        Rechazar
                      </Button>
                    </Td>
                  </Tr>
                );
              }),
              // Pagination controls row
              <tr key="pagination-controls">
                <Td colSpan={9}>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                  />
                </Td>
              </tr>
            ];
          }
        })()}
      </tbody>
    </table>
  );
};

PaymentsTable.propTypes = {
  loading: PropTypes.bool.isRequired,
  filtered: PropTypes.array.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  handleApprove: PropTypes.func.isRequired,
  handleReject: PropTypes.func.isRequired,
  Tr: PropTypes.elementType.isRequired,
  Td: PropTypes.elementType.isRequired,
  Th: PropTypes.elementType.isRequired,
  StatusBadge: PropTypes.elementType.isRequired,
  Button: PropTypes.elementType.isRequired,
};

export default PaymentsTable;
